/* eslint-disable react/jsx-no-bind */
import CartHelper from "../../shared/modules/CartHelper";
import Helper from "../../shared/modules/Helper";
import PropTypes from "prop-types";
import React from "react";

const NonMemberBillingInfo = ({billingInfo, setIsEditingBilling}) => {
  const {
    lastFour,
    paymentMethod
  } = billingInfo;

  const hasValidBillingInfo = () => CartHelper.hasBillingInfo(billingInfo);

  const handleEditBillingInfo = () => {
    setIsEditingBilling(true);
  };

  if (!hasValidBillingInfo()) return null;

  return (
    <div className="billing-info cart-block">
      <div className="header">
        <div className="title">
          billing
        </div>
        {
          !hasValidBillingInfo() &&
          <div className="quantity-field">
            <div
              className="increase-quantity-button increase-btn"
              onClick={handleEditBillingInfo}
              type="button"
            />
          </div>
        }
        {
          hasValidBillingInfo() &&
          <a
            className="credit-card-edit"
            onClick={handleEditBillingInfo}
          >
            Edit
          </a>
        }
      </div>

      { paymentMethod && lastFour &&
        <div>
          <div className="billing-text">
            {`Paying with ${paymentMethod ? Helper.snakecaseToTitle(paymentMethod) : ""}`}
          </div>
          <div className="credit-card-info">
            {`Credit card ending with *${lastFour}`}
          </div>
        </div>
      }
    </div>
  );
};

NonMemberBillingInfo.propTypes = {
  "billingInfo": PropTypes.object.isRequired,
  "setIsEditingBilling": PropTypes.func.isRequired
};

export default NonMemberBillingInfo;
